import { render, staticRenderFns } from "./rate.vue?vue&type=template&id=65fde672&scoped=true&"
import script from "./rate.vue?vue&type=script&lang=js&"
export * from "./rate.vue?vue&type=script&lang=js&"
import style0 from "./rate.vue?vue&type=style&index=0&id=65fde672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fde672",
  null
  
)

export default component.exports